import lazyImporter from '@/utils/lazyImporter'

const collectionRoute = {
  component: lazyImporter('View'),
  meta: { title: 'collections', icon: 'library_books' },
  name: 'admin_collection',
  path: '/collection',
  redirect: { name: 'admin_collection_list' },
  children: [
    {
      component: lazyImporter('collection/CollectionList'),
      meta: { title: 'collectionList', hidden: true },
      name: 'admin_collection_list',
      path: ''
    },
    {
      component: lazyImporter('collection/CollectionUpdate'),
      meta: { title: 'collectionUpdate', hidden: true },
      name: 'admin_collection_update',
      path: ':slug/update',
      props: true
    },
    {
      component: lazyImporter('collection/CollectionAdd'),
      meta: { title: 'collectionAdd', hidden: true },
      name: 'admin_collection_add',
      path: 'add'
    }
  ]
}

export default collectionRoute
